<template>
  <div class="container-codeandcontrols">
    <div class="container-codeandcontrols__code-in-input" v-if="status == 1">
      <input
        class="inputcodetype"
        v-model="inputValue"
        @input="checkInputLength"
        type="text"
        placeholder="Ingresa tu código de descuento"
      />
      <div class="bnt-aply-code" :class="activeBtn ? 'active-btn' : ''" @click="clickInsertCode">Aplicar código</div>
      <div class="leyend-error" v-if="showAlert">El código de descuento es incorrecto</div>
    </div>
    <div class="container-codeandcontrols__code-question" v-if="status == 0" @click="clickGetCode">
      <img src="/images/iconocodigo.png" />
      <span class="container-codeandcontrols__code-question__txt-pc">¿Tienes un código de regalo?</span>
      <span class="container-codeandcontrols__code-question__txt-mobile">Código de regalo</span>
    </div>
    <div class="container-codeandcontrols__code-container" v-if="status == 2">
      <div class="close-code">X</div>
      <div class="container-codeandcontrols__code-container__item-img"></div>
      <div class="container-codeandcontrols__code-container__info-code">
        <div class="container-codeandcontrols__code-container__info-code__title">Codigo aplicado:</div>
        <div class="container-codeandcontrols__code-container__info-code__code">HLOZANO</div>
      </div>
    </div>
    <div class="container-codeandcontrols__control">
      <BField>
        <span class="container-codeandcontrols__control__label">
          Mensual
        </span>
        <BSwitch inset size="is-small" color="secondary" v-model="isSwitchedSection"></BSwitch>
        <span class="container-codeandcontrols__control__label">
          Anual
        </span>
      </BField>
    </div>
  </div>
</template>
<script>
import Input from '../../Form/Input.vue';
export default {
  name: 'CodeAndControls',
  components: { Input },
  data() {
    return {
      isSwitchedSection: false,
      status: 0,
      inputValue: '',
      initialLength: 0,
      activeBtn: false,
      showAlert: false,
    };
  },
  computed: {},
  watch: {
    isSwitchedSection() {
      this.$emit('typePackege', this.isSwitchedSection);
    },
  },
  methods: {
    clickGetCode() {
      this.status = 1;
    },
    clickInsertCode() {
      if (this.inputValue === 'no') {
        this.showAlert = true;
      } else {
        this.status = 2;
      }
    },
    checkInputLength() {
      const currentLength = this.inputValue.length;
      this.showAlert = false;
      // if (currentLength !== this.initialLength) {
      if (currentLength > 0) {
        this.activeBtn = true;
      } else {
        this.activeBtn = false;
      }
      // }
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss">
.container-codeandcontrols {
  .switch {
    margin-top: 3px !important;
    margin-left: 10px;
    width: 50px;
    @media screen and (max-width: 628px) {
      width: 44px;
    }
    @media screen and (max-width: 380px) {
      width: 38px;
      margin-left: 8px;
    }
  }
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover {
    background: transparent !important;
  }
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover,
  .switch input[type='checkbox']:checked + .check:hover {
    background: transparent !important;
    box-shadow: none !important;
  }
  .switch input[type='checkbox'] + .check {
    background: transparent !important;
    box-shadow: none !important;
    border: 1px solid white;
    width: 48px;
    height: 27px;
    border-radius: 18px;

    @media screen and (max-width: 768px) {
      width: 44px;
      height: 24px;
    }
    @media screen and (max-width: 698px) {
      width: 42px;
      height: 22px;
    }
    @media screen and (max-width: 628px) {
      width: 40px;
      height: 22px;
    }
    @media screen and (max-width: 480px) {
      width: 42px;
      height: 22px;
    }
    @media screen and (max-width: 380px) {
      width: 38px;
      height: 22px;
    }
  }
  .switch input[type='checkbox'] + .check:before {
    background: #cbee6b !important;
    height: 20px;
    width: 20px;
    @media screen and (max-width: 768px) {
      height: 18px;
      width: 18px;
    }
    @media screen and (max-width: 698px) {
      height: 17px;
      width: 17px;
    }
    @media screen and (max-width: 628px) {
      height: 16px;
      width: 16px;
    }
    @media screen and (max-width: 480px) {
      height: 17px;
      width: 17px;
    }
    @media screen and (max-width: 380px) {
      height: 16px;
      width: 16px;
    }
  }
}
</style>
<style lang="scss" scoped>
.close-code {
  width: 20px;
  height: 20px;
  position: absolute;
  font-family: 'Avenir-Regular';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
  padding-right: 5px;
  padding-top: 3px;
  color: #fff;
  right: 0;
  cursor: pointer;
}
.leyend-error {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.83;
  letter-spacing: normal;
  text-align: center;
  color: #ea5151;
  font-family: 'Avenir-Regular';
  margin-left: 24px;
}
.bnt-aply-code {
  border-radius: 20px;
  border: solid 1px #000;
  background-color: #c8d2de;
  width: 133px;
  height: 36px;
  font-family: 'Avenir-Demi';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 32px;
  letter-spacing: -0.14px;
  margin-left: 16px;
  text-align: center;
  color: #fff;
}
.active-btn {
  background: #00a1e6 !important;
  cursor: pointer;
}
.inputcodetype {
  background: transparent;
  width: 280px;
  height: 36px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 36px;
  letter-spacing: normal;
  text-align: left;
  padding-left: 10px;
  margin-left: 26px;
  border-radius: 4px;
  border: solid 1px #8e8e8e;
  color: #c1c1c1;
  @media screen and (max-width: 768px) {
    width: 72%;
  }
  @media screen and (max-width: 715px) {
    width: 71%;
  }
  @media screen and (max-width: 680px) {
    width: 70%;
  }
  @media screen and (max-width: 660px) {
    width: 69%;
  }
  @media screen and (max-width: 640px) {
    width: 68%;
  }
  @media screen and (max-width: 620px) {
    width: 67%;
  }
  @media screen and (max-width: 600px) {
    width: 66%;
  }
  @media screen and (max-width: 580px) {
    width: 65%;
  }
  @media screen and (max-width: 560px) {
    width: 64%;
  }
  @media screen and (max-width: 540px) {
    width: 63%;
  }
  @media screen and (max-width: 520px) {
    width: 61%;
  }
  @media screen and (max-width: 500px) {
    width: 59%;
  }
  @media screen and (max-width: 480px) {
    width: 57%;
  }
  @media screen and (max-width: 460px) {
    width: 55%;
  }
  @media screen and (max-width: 440px) {
    width: 53%;
  }
  @media screen and (max-width: 420px) {
    width: 51%;
  }
  @media screen and (max-width: 400px) {
    width: 49%;
  }
  @media screen and (max-width: 380px) {
    width: 47%;
  }
  @media screen and (max-width: 360px) {
    width: 45%;
  }
  @media screen and (max-width: 340px) {
    width: 39%;
  }
  @media screen and (max-width: 320px) {
    width: 36%;
  }
}
.container-codeandcontrols {
  width: 100%;
  height: 58px;
  margin-top: 50px;
  display: inline-flex;
  justify-content: space-between;
  border-radius: 12px;
  position: relative;
  // background-color: rgba(20, 20, 20, 0.6);
  @media screen and (max-width: 768px) {
    background-color: transparent;
    margin-top: 150px;
  }
  @media screen and (max-width: 698px) {
    margin-top: 145px;
  }
  @media screen and (max-width: 628px) {
    margin-top: 140px;
  }
  @media screen and (max-width: 480px) {
    margin-top: 130px;
  }
  @media screen and (max-width: 380px) {
    margin-top: 120px;
  }
  @media screen and (max-width: 370px) {
    margin-top: 115px;
  }
  @media screen and (max-width: 360px) {
    margin-top: 110px;
  }
  @media screen and (max-width: 350px) {
    margin-top: 105px;
  }
  @media screen and (max-width: 340px) {
    margin-top: 100px;
  }
  @media screen and (max-width: 330px) {
    margin-top: 85px;
  }
  @media screen and (max-width: 320px) {
    margin-top: 90px;
  }
  &__code-in-input {
    width: 750px;
    height: 58px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    font-family: 'Avenir-Regular';
    @media screen and (max-width: 968px) {
      width: 550px;
    }
    @media screen and (max-width: 835px) {
      width: 450px;
    }
    @media screen and (max-width: 768px) {
      position: absolute;
      justify-content: left;
      align-content: left;
      align-items: left;
      width: 100%;
    }
  }
  &__code-question {
    width: 350px;
    height: 58px;
    display: inline-flex;
    justify-content: left;
    font-size: 17px;
    font-family: 'Avenir-Demi';
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 58px;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    text-decoration: underline;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      font-size: 15px;
    }
    @media screen and (max-width: 698px) {
      font-size: 14px;
    }
    @media screen and (max-width: 628px) {
      font-size: 13px;
    }
    @media screen and (max-width: 480px) {
      font-size: 15px;
    }
    @media screen and (max-width: 380px) {
      font-size: 13px;
    }
    span {
      margin-left: 10px;
      @media screen and (max-width: 768px) {
        margin-left: 8px;
      }
      @media screen and (max-width: 698px) {
        margin-left: 7px;
      }
      @media screen and (max-width: 628px) {
        margin-left: 4px;
      }
      @media screen and (max-width: 480px) {
        margin-left: 6px;
      }
      @media screen and (max-width: 380px) {
        margin-left: 4px;
      }
    }
    img {
      width: 31px;
      height: 31px;
      margin-top: 15px;
      @media screen and (max-width: 768px) {
        width: 29px;
        height: 29px;
        // margin-top: 16px;
      }
      @media screen and (max-width: 698px) {
        width: 28px;
        height: 28px;
        margin-top: 16px;
      }
      @media screen and (max-width: 628px) {
        width: 27px;
        height: 27px;
      }
      @media screen and (max-width: 480px) {
        width: 30px;
        height: 30px;
        margin-top: 14px;
      }
      @media screen and (max-width: 380px) {
        width: 27px;
        height: 27px;
        margin-top: 15px;
      }
    }
    &__txt-pc {
      display: inline-block;
      @media screen and (max-width: 480px) {
        display: none;
      }
    }
    &__txt-mobile {
      display: none;
      @media screen and (max-width: 480px) {
        display: inline-block;
      }
    }
  }
  &__code-container {
    width: 230px;
    height: 58px;
    position: relative;
    display: inline-flex;
    border-radius: 9px;
    // background-color: rgba(27, 27, 27, 0.4);
    justify-content: left;
    @media screen and (max-width: 768px) {
      background-color: transparent;
      width: 200px;
    }
    @media screen and (max-width: 480px) {
      width: 140px;
    }
    @media screen and (max-width: 380px) {
      width: 140px;
    }
    &__item-img {
      width: 50px;
      height: 50px;
      border: 1px solid #cbee6b;
      border-radius: 50px;
      margin-left: 20px;
      margin-top: 4px;
      background: white;
      @media screen and (max-width: 768px) {
        width: 48px;
        height: 40px;
        border-radius: 80px;
      }
      @media screen and (max-width: 480px) {
        position: absolute;
        width: 33px;
        height: 33px;
        margin-top: -27px;
        margin-left: 10px;
      }
    }
    &__info-code {
      width: 150px;
      height: 58px;
      margin-left: 12px;
      @media screen and (max-width: 768px) {
        height: 40px;
        margin-top: 3px;
      }
      &__title {
        width: 100%;
        height: 29px;
        font-family: 'Avenir-Bold';
        font-size: 14px;
        font-weight: normal;
        color: white;
        font-stretch: normal;
        font-style: normal;
        line-height: 35px;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          height: 20px;
          line-height: 27px;
        }
      }
      &__code {
        width: 100%;
        height: 29px;
        color: white;
        font-family: 'Avenir-Regular';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0.98px;
        font-style: normal;
        line-height: 20px;
        font-weight: 600;
        text-align: left;
        color: #fff;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          height: 22px;
        }
      }
    }
  }
  &__control {
    width: 177px;
    height: 58px;
    display: inline-flex;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
      width: 157px;
    }
    // @media screen and (max-width: 698px) {
    // }
    @media screen and (max-width: 628px) {
      width: 145px;
    }
    @media screen and (max-width: 480px) {
      width: 157px;
    }
    @media screen and (max-width: 380px) {
      width: 140px;
    }
    &__label {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      margin-top: 4px;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      font-family: 'Avenir-Regular';
      line-height: 53px;
      @media screen and (max-width: 768px) {
        font-size: 13px;
      }
      @media screen and (max-width: 698px) {
        font-size: 13px;
      }
      @media screen and (max-width: 628px) {
        font-size: 12px;
      }
      @media screen and (max-width: 480px) {
        font-size: 13px;
      }
      @media screen and (max-width: 380px) {
        font-size: 11px;
      }
    }
  }
}
</style>
